var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('EditForm',{attrs:{"fields":_vm.fields,"title":"Tooleinstellungen","api_read":"company/getcompany","api_write":"company/SetLevelOfDetail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }